import type { ClassDefinition } from "@hd2/data";
import { useMatches } from "@tanstack/react-router";
import { useClasses } from "./use-classes.ts";

/**
 * Returns the class whose dossier is currently being viewed, or null if the
 * current route is not a class dossier.
 */
export function useDossierClass(): ClassDefinition | null {
	const matches = useMatches();
	const { classes } = useClasses();

	for (const m of matches) {
		if (m.routeId === "/classes/$slug") {
			const slug = (m.params as { slug?: string }).slug;
			if (slug) {
				return classes.find((c) => c.slug === slug) ?? null;
			}
		}
	}
	return null;
}
